import { BadgeCheck } from "lucide-react";

export const VerifiedBadge = ({ compact = false }) => (
  <span
    data-testid="verified-badge"
    className={`inline-flex items-center gap-1.5 bg-stranger-orange text-clean-white font-bold rounded-full ${
      compact ? "text-[10px] px-2.5 py-1" : "text-xs px-3 py-1.5"
    }`}
  >
    <BadgeCheck className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} /> {compact ? "VERIFIED" : "OFFICIAL STRANGER SESSIONS PHOTOGRAPHER"}
  </span>
);
